import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress, Alert } from '@mui/material';

const BalanceComptable = () => {
  const [balance, setBalance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Récupération des données de la balance depuis l'API
  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await axios.get('/api/balance-comptable');
        setBalance(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBalance();
  }, []);

  // Affichage des données
  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">Erreur : {error}</Alert>;

  return (
    <div className="balance-comptable">
      <Typography variant="h4" gutterBottom>
        Balance Comptable
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Compte</TableCell>
              <TableCell>Libellé</TableCell>
              <TableCell>Débit</TableCell>
              <TableCell>Crédit</TableCell>
              <TableCell>Solde</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {balance.map((item) => (
              <TableRow key={item.compte}>
                <TableCell>{item.compte}</TableCell>
                <TableCell>{item.libelle}</TableCell>
                <TableCell>{item.debit.toFixed(2)} €</TableCell>
                <TableCell>{item.credit.toFixed(2)} €</TableCell>
                <TableCell>{(item.debit - item.credit).toFixed(2)} €</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default BalanceComptable;
